import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableDriver } from "./autogen/AutogenLayoutUserTableDriver";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableDriver extends AutogenLayoutUserTableDriver implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.DRIVER;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
